import { FormGroup } from '@angular/forms';
import { createAction, props } from '@ngrx/store';
import { MemberModel, TeamModel, TeamRoleModel, UserTeamModel } from '../../../../models/team-permissions.model';

export const loadTeamsInit = createAction('[Teams] Load Teams Init', props<{ request: any }>());
export const loadTeamsSuccess = createAction('[Teams] Load Teams Success', props<{ totalRecords: number }>());
export const loadTeamsFailure = createAction('[Teams] Load Teams Failure', props<{ error: string }>());

export const loadMembersInit = createAction('[Teams] Load Members Init', props<{ request: any }>());
export const loadMembersSuccess = createAction('[Teams] Load Members Success');
export const loadMembersFailure = createAction('[Teams] Load Members Failure', props<{ error: string }>());

export const updateTeamInit = createAction('[Teams] Update Team Init', props<{guid: string, team: FormGroup}>());
export const updateTeamSuccess = createAction('[Teams] Update Team Success');
export const updateTeamFailure = createAction('[Teams] Update Team Failure', props<{error: string}>());

// members = member subject guids
export const addMembersInit = createAction('[Teams] Add Members Init', props<{teamGuid: string, members: string[], rank: string}>());
export const addMembersSucess = createAction('[Teams] Add Members Success');
export const addMembersFailure = createAction('[Teams] Add Members Failure', props<{error: string}>());

export const updateMemberInit = createAction('[Teams] Update Member Init', props<{guid: string, member: FormGroup}>());
export const updateMemberSuccess = createAction('[Teams] Update Member Success');
export const updateMemberFailure = createAction('[Teams] Update Member Failure', props<{error: string}>());

export const deleteMemberInit = createAction('[Teams] Delete Member Init', props<{guid: string}>());
export const deleteMemberSuccess = createAction('[Teams] Delete Member Success');
export const deleteMemberFailure = createAction('[Teams] Delte Member Failure', props<{error: string}>());

// update role details
export const updateRoleInit = createAction('[Teams] Update Role Init', props<{guid: string, role: FormGroup}>());
export const updateRoleSuccess = createAction('[Teams] Update Role Success');
export const updateRoleFailure = createAction('[Teams] Update Role Failure', props<{error: string}>());

// delete role
export const deleteRoleInit = createAction('[Teams] Delete Role Init', props<{guid: string}>());
export const deleteRoleSuccess = createAction('[Teams] Delete Role Success');
export const deleteRoleFailure = createAction('[Teams] Delete Role Failure', props<{error: string}>());

export const selectGuid = createAction('[Teams] Select Guid', props<{guid: string}>());
export const selectTeam = createAction('[Teams] Select Team', props<{team: TeamModel}>());
export const selectDetailsForm = createAction('[Teams] Select Details Form', props<{form: any}>());
export const setRequiresUpdate = createAction('[Teams] Set Update Options', props<{update: boolean}>());
export const setCurrentUser = createAction('[Teams] Set Current User', props<{currentUser: UserTeamModel}>());
export const selectTeamRole = createAction('[Teams] Select Team Role', props<{teamRole: TeamRoleModel}>());
export const setUpdateTeamListing = createAction('[Teams] Set Update Team Listing', props<{update: boolean}>());
export const selectMember = createAction('[Teams] Select Member', props<{member: MemberModel}>());
export const setUpdateMemberListing = createAction('[Teams] Set Update Member Listing', props<{update: boolean}>());
export const setUpdateAddMemberListing = createAction('[Teams] Set Update Add Member Listing', props<{update: boolean}>());
export const setUpdateRoleListing = createAction('[Teams] Set Update Role Listing', props<{update: boolean}>());
